import React from 'react';
import Hero from '../components/Hero';
import Bio from '../components/Bio';
import Follow from '../components/Follow';
import Videos from '../components/Videos';
import Shop from '../components/Shop';
import Newsletter from '../components/Newsletter';

export default function HomePage() {
  return (
    <main>
      <Hero />
      <Bio />
      <Follow />
      <Videos />
      <Shop showFilters={false} limit={4} />
      <Newsletter />
    </main>
  );
}
